import {
  PortableText as PortableTextReactComponent,
  toPlainText,
} from "@portabletext/react";
import slugify from "slugify";

export type PortableTextComponents = React.ComponentProps<
  typeof PortableTextReactComponent
>["components"];

export const portableTextComponents: Partial<PortableTextComponents> = {
  types: {
    h1: ({ value }) => <h1 id={slugify(toPlainText(value))}>{value}</h1>,
    h2: ({ value }) => <h2 id={slugify(toPlainText(value))}>{value}</h2>,
    h3: ({ value }) => <h3 id={slugify(toPlainText(value))}>{value}</h3>,
    normal: ({ value }) => <p>{value}</p>,
  },
  marks: {
    bold: ({ children }) => <strong>{children}</strong>,
    em: ({ children }) => <em>{children}</em>,
  },
  list: {
    bullet: ({ children }) => <ul>{children}</ul>,
    number: ({ children }) => <ol>{children}</ol>,
  },
  listItem: {
    bullet: ({ children }) => <li>{children}</li>,
  },
};
